<script lang="ts">
import Vue from 'vue'
import { getRegions, getRegionInfo } from "@/api/organizations/organizations";

export default Vue.extend({
    name: "OrganizationFilter",
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            required: true,
        }
    },
    data() {
        return {
            regions: [],
            loadRegions: false,
            regionId: null,
            branchId: null,
            branches: [],
        }
    },
    methods: {
        changeRegion() {
            let region = this.regions.find(item => item.id === this.regionId)
            this.branches = region ? region.children : [];
            this.branchId = null

            this.$emit('update', this.regionId)
        }
    },
    created() {
        this.loadRegions = true;
        switch (this.$store.getters.USER.organizationType) {
            case 'head':
                getRegions({organizationId: this.$store.getters.USER.organizationId}).then(response => {
                    this.regions = response.data;
                    this.loadRegions = false;
                })
                break
            case 'region':
                getRegionInfo(this.$store.getters.USER.organizationId).then(response => {
                    this.branches = response.data.children
                })
                break
        }
    }
})
</script>

<template>
<div class="row">
    <div class="col-sm-4 form-group" v-if="$store.getters.USER.organizationType === 'head'">
        <div class="filter-title">
            Дирекція
        </div>
        <el-select v-model="regionId"
                   class="form-control-el"
                   placeholder="Виберіть торгову точку"
                   @change="changeRegion"
                   clearable
        >
            <el-option v-for="item in regions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
        </el-select>
    </div>
    <div class="col-sm-4 form-group" v-if="$store.getters.USER.organizationType !== 'branch'">
        <div class="filter-title">
            Відділення
        </div>
        <el-select v-model="branchId"
                   class="form-control-el"
                   clearable
                   @change="$emit('update', $event)"
                   placeholder="Виберіть торгову точку">
            <el-option v-for="item in branches"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
        </el-select>
    </div>
</div>
</template>

<style scoped>

</style>
